/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import Auth from "../shared/Auth";
import BaseCom from "./BaseCom";
import LoadingAlert from "./LoadingAlert";
import { withParamsAndNavigate } from "./WithParamsAndNavigate";

class Index extends BaseCom {
    componentDidMount() {
        setTimeout(() => {
            this.props.navigate('/landing/home');
        },10);
    }

    render() {
        return <LoadingAlert />;
    }
}

export default withParamsAndNavigate(Index);